jQuery(document).ready(function ($) {

    function setAnnouncement(){
        setTimeout(function(){
            // console.log('ran');
            var announcementBannerHeight = $('#announcement-bar').outerHeight(),
                sitesBannerHeight = $('#allsites-bar').outerHeight(),
                // currBodyPadding = parseInt($('body').css('padding-top')),
                currMobileMenuTop = parseInt($('#menu-mobile-menu').css('margin-top')),
                currHeaderHeight = parseInt($('#global-header').css('height')),

                mobilenav = $(window).height() - announcementBannerHeight - currHeaderHeight;
                $('.dropdownmenu').css({
                    'top': currHeaderHeight,
                    'max-height': $(window).height() - currHeaderHeight
                });
                $('#shop-dropdown').css('top', currHeaderHeight );
                // $('body').css('padding-top', currHeaderHeight );
                
                $('.search-modal').css('top', currHeaderHeight );
                $('.header__search--has-predictive>details[open] .predictive-search__overlay').css('top', currHeaderHeight + $('.search-modal').outerHeight() );
                $('#mobile-global-nav').css('top', currHeaderHeight );
                $('#desktop-shop-nav').css('top', currHeaderHeight );
                // $('.dropdownmenu').css('max-height', "calc(100vh - " + currHeaderHeight+ " )" )

                $('#desktop-shop-nav').css('top', currHeaderHeight );

                if( $(window).width() < 500 ){
                    $('#shop-decor .inner, #shop-decor .inner-2').css('height', mobilenav );
                }

            }, 500);
    }

    function general_resp() {

        setAnnouncement();
        
        function tabletcond(){
            if( $(window).width() < 1181){
                $('#xxxxxxxxxxxx').removeAttr('href');
            }
        }
        tabletcond();

        function setheader(){
            // console.log('ran');
            var currHeaderHeight = parseInt($('#global-header').css('height'));

            $('body').css('padding-top', currHeaderHeight )
        }
        setheader();

    }

    function about(){
        if( $('#about-menu').length > 0  ){

            $('.detailedsection-title').on('click', function(e) {
                e.preventDefault()

                var slug = $(this).data('name');
                
                $('html, body').animate({
                    scrollTop: $('#'+slug+'-section').offset().top - ( $('#global-header').height() * .5),
                }, 650, 'easeOutQuad' );
            });

            var tol = $(window).height() * .5;
            $('.about-section').each(function(){
                $(this).onScreen({
                    container: window,
                    direction: 'vertical',
                    doIn: function(){

                        $('.about-link').removeClass('active');
                        var activename = $(this).data('name');

                        $('#link--'+activename).addClass('active');

                        console.log( $('#link--'+activename).addClass('active') );
                    },
                    doOut: function() {
                       // var theid = $(this).attr('id');
                       // $('#'+theid+'-indicator').removeClass('red-color')
                       // console.log('out'+theid);
                    },
                    tolerance: tol,
                    throttle: 50,
                    toggleClass: 'onScreen',
                    lazyAttr: null,
                    debug: false
                });
            });


            function stickit(){
                if( $(window).width() > 581  ){
                    console.log('sticky');
                    $('#section-menu').sticky({
                        context: '.wrapperx > .clearfix',
                        // offset: $('#homepage-experience-txt').offset().top
                        // offset: $('#global-header').offset().top
                        offset: -100
                    });
                }
            }
            // stickit();
        }
    }
    function general(){

        jQuery(function($) {
  var $btn = $("#home-collection-toggle");
  var $submenu = $("#mobilesubmenu-home-collection");

  $btn.on("click", function(e) {
    e.preventDefault();

    var expanded = $btn.attr("aria-expanded") === "true";
    $btn.attr("aria-expanded", !expanded);

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      if (expanded) {
        $submenu.hide().attr("aria-hidden", "true");
      } else {
        $submenu.show().attr("aria-hidden", "false");
      }
    } else {
      $submenu.stop(true, true).slideToggle(200, function() {
        var nowHidden = $(this).is(":hidden");
        $(this).attr("aria-hidden", nowHidden ? "true" : "false");
      });
    }

    $btn.find(".chevron").toggleClass("open", !expanded);
  });

  // Escape key closes
  $btn.on("keydown", function(e) {
    if ((e.key === "Escape" || e.key === "Esc") && $btn.attr("aria-expanded") === "true") {
      e.preventDefault();
      $btn.click();
      $btn.focus();
    }
  });
});


      $('#home-collection-link').hover(
        function () {
          $('#home-collection-dropdown').addClass('active');
        },
        function () {
          setTimeout(function () {
            if (!$('#home-collection-dropdown').is(':hover')) {
              $('#home-collection-dropdown').removeClass('active');
            }
          }, 200);
        }
      );

      $('#MainContent, .main-nav > a:not(#home-collection-link)').on('mouseenter', function () {
        $('#home-collection-dropdown').removeClass('active');
      });





      //dropdown collection hover
      $('.dropdown-collection-link').off('mouseenter');

      $('.dropdown-collection-link').on('mouseenter', function (e) {
        e.preventDefault();

        $('.dropdown-collection-link h4').removeClass('blue-color');
        $(this).find('h4').addClass('blue-color');

        var activeID = $(this).attr('id');
        console.log(activeID);
        $('#home-collection-dropdown .dropdown-product-group').removeClass('active');
        $('#container-'+activeID).addClass('active');
      });



        $('.search-button, .close').off('click').on('click', function (e) {
          e.preventDefault(); // prevent default if button is inside a form
          $('#header-search-container').toggleClass('active');
        });


        $('.product-section .title-section').off("click").on("click", function(e) {
            $(this).parent().toggleClass('active');
        });
        

        $('.collection-filter-menu-section .borderedtitle').off("click").on("click", function(e) {
            $(this).parents('.collection-filter-menu-section').toggleClass('active');
        }); 

        $('.toggledropdown').off("click").on("click", function(e) {
            $('.collectioncustommenu').toggleClass('active');
        }); 


        $('.search-icon').off("click").on("click", function(e) {
            console.log('search');

            if( $(this).hasClass('active')){
                $(this).removeClass('active');
                $('.searchmain').attr('open', false);
            } else {
                $(this).addClass('active');
                $('.searchmain').attr('open', true);
            }
        }); 

        if( $('#about-menuxx').length > 0 ){
            $(window).scroll(function() {
                var top_of_element = $(".about-section").offset().top;
                var bottom_of_element = $(".about-section").offset().top + $(".about-section").outerHeight();
                var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
                var top_of_screen = $(window).scrollTop();

                if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
                    // the element is visible, do something
                } else {
                    // the element is not visible, do something else
                }
            });
        }

        
        $('.about-title-container').off("click").on("click", function(e) {
            $(this).parent().parent().toggleClass('active');
            var titleactive = $(this).parent().parent().data('name');

            if (titleactive == 'our-locations'){
                $('.subsection').toggleClass('active');
            }


        });

        $('.mobile-main-nav-item:not(.nav-heading)').off("click").on("click", function(e) {
            console.log('asdf');
            var activeitem = $(this).data('name');
            $('#global'+activeitem+'-desktop-nav-item-dropdown').addClass('active');
            console.log('#globalfor-'+activeitem+'-desktop-nav-item-dropdown');
        }); 

        $('.backbtn').off("click").on("click", function(e) {
            console.log('backbtn');
            $('.dropdownmenu').removeClass('active');
            $('#mobile-global-nav').addClass('active-mobile-nav');
        }); 

        $('.nav-heading:not(.backbtn)').off("click").on("click", function(e) {
            $(this).parents('.nav-group').toggleClass('active');
        });

        // Select all links with hashes
        $('.about-linkxx').click(function(event) {
            // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

            $('.about-link').removeClass('active');
            $(this).addClass('active');
            // Figure out element to scroll to
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 500, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          });

        $('.main-nav-item').mouseenter(function(){
            
            $('.dropdownmenu.active').removeClass('active');

            var active = $(this).attr('id');
            console.log('nav hover '+active);
            $('#'+active+'-dropdown').addClass('active');
        });

        $('#MainContent, .footer-groups, .headermainbg').mouseenter(function(){
            $('.dropdownmenu').removeClass('active');
        });

        $('.tab-button-container a').off("click").on("click", function(e) {
            var activething = $(this).data('name');

            $('.prod_tab, .tab-button-container a').removeClass('active');

            $(this).addClass('active');
            $('.tab-button-container a:not(.active)').addClass('outlinebtn')
            $('.'+activething).addClass('active');
        });
        

        // BLUEIMP
        if( $('#blueimp-gallery').length > 0 && $('#links').length > 0 ){
            console.log('yes');
            $('#blueimp-gallery .close').on('click', function(){
                blueimp.close()
            });
            
            

        }

        $('#shop-decor .back').off("click").on("click", function(e) {
            $('#shop-decor').removeClass('active');
            $('.main-nav-item--shop-decor').removeClass('active');
        });


        $("#desktop-global-nav .h4.shop-nav-item, #shop-decor-desktop-nav-item").mouseenter(function(){
            $('#shop-decor').addClass('active');
            $(this).addClass('active');
        });

        $('#shop-decor-mobile-nav-item').off("click").on("click", function(e) {
            $('#shop-decor').addClass('active');
            

            $('.nav-dropdown-item .nav-dropdown-children').each(function(){
                var activeheight = $(this).css('height');
                console.log(activeheight);
                $(this).css('height', activeheight);
            });

            $('.nav-dropdown-item').removeClass('active');


        });

        if( $(window).width() > 500 ){
            $("#MainContent, #global-footer, .announcement-banner, #header-items h4:not(.main-nav-item--shop-decor)").mouseenter(function(){
                $('#shop-decor').removeClass('active');
                $('.main-nav-item--shop-decor').removeClass('active');
            });
        } else {
            $('.facets__details').removeAttr('open');
        }




        $('.modal__close-button.link').off("click").on("click", function(e) {
            $('.searchmain').removeAttr('open')
        });



        

        $('.nav-dropdown-title').off("click").on("click", function(e) {
            $('.nav-dropdown-item').removeClass('active');
            $(this).parents('.nav-dropdown-item').toggleClass('active');

            

        });

              

              

              


        // FAQ
        $('.faq-container .expand-button-container').off("click").on("click", function(e) {
            // if( !$(this).parent().hasClass('active') ){
                $(this).parents('.faq-container').toggleClass('active');
                $(this).parents('.faq-container').find('h3').toggleClass('mb4');
        });
        
        
        $('.about-swap-button').on('click', function(){
            $('.about-swap-button').removeClass('active darktaupe-color');
            $(this).addClass('active darktaupe-color');

            var activename = $(this).data('name');
            $('.info-section').removeClass('active');
            $('.'+activename+'-container').addClass('active');

            $('.services-feat-image').removeClass('active');
            $('.'+activename+'-feat_image').addClass('active');

        });

        if( $('.template-index').length > 0 ){
            $(window).scroll(function () {
                var y = $(this).scrollTop();

                if (y >= $('body').offset().top + 200) {
                    $('#global-header').removeClass('homepage-header-notactive');    
                } else {
                    $('#global-header').addClass('homepage-header-notactive');
                }
            });
        }

       




        function headerBackground() {
            $( document ).ready(function() {
                var header = $('#global-header'),
                    winHeight = $(window).height(),
                    top,
                    bannerOffset = $('#main-banner img').outerHeight()*.8,
                    homepageOffset = 200,
                    singleProjectOffset = $('#slider-container').outerHeight(),
                    headerHeight = header.height();


            if( $('.template-indexxx').length > 0 ) {
                top = $('body').offset().top + homepageOffset;
                // console.log('homepageOffset '+ homepageOffset);

            } else {
                top = $('body').offset().top + 200;
                // console.log('bannerOffset '+ bannerOffset);

            }
        
            $(window).scroll(function () {
                var y = $(this).scrollTop();
                if (y >= top) {
                    header.addClass('active-header');
                    setAnnouncement(); 
                } else {
                    header.removeClass('active-header');    
                    setAnnouncement(); 
                }
            });
            });
        };
        headerBackground();
        
        $(document).keyup(function(e) {
            if (e.keyCode == 27) {

                $('html').removeClass('has-fullscreen-item');
                $('body').removeClass('has-popup');

                if( $('#mobile-global-nav').hasClass('active-mobile-nav')){
                    $('#mobile-nav-button').removeClass('active-mobile-nav-button');
                    $('body').removeClass('mobile-nav-active-body');
                    $('#mobile-global-nav').removeClass('active-mobile-nav');
                    $('#global-header').removeClass('active-mobile-nav');
                    $('html').removeClass('has-fullscreen-item');
                    $('body').removeClass('has-popup');
                    $('.dropdownmenu').removeClass('active');

                    mobileNavFlag = false;              
                }
            }
        });
        
        //mobile Button
        var mobileNavFlag = false;
        $(document).find('#mobile-nav-button').off("click").on("click", function(e) {
            e.preventDefault();   
            
            if( mobileNavFlag == false){
                $(this).attr('aria-expanded', true);
                $(this).addClass('active-mobile-nav-button');
                $('body').addClass('mobile-nav-active-body');
                $('#global-header').addClass('active-mobile-nav');
                $('html').addClass('has-fullscreen-item');

                $('#mobile-global-nav').addClass('active-mobile-nav');

                mobileNavFlag = true;               
                e.stopPropagation();  
            } else {
                $(this).attr('aria-expanded', false);
                $(this).removeClass('active-mobile-nav-button');
                $('body').removeClass('mobile-nav-active-body');
                $('#mobile-global-nav').removeClass('active-mobile-nav');
                $('#global-header').removeClass('active-mobile-nav');
                $('html').removeClass('has-fullscreen-item');
                $('.dropdownmenu').removeClass('active');

                $('#shop-decor').removeClass('active');
                $('.main-nav-item--shop-decor').removeClass('active');
                
                mobileNavFlag = false;              
                e.stopPropagation();      
            } 
        });

        // $('.mobile-nav-item').off("click").on("click", function(e) {
        //     $(this).toggleClass('active');
        // });

        // $('.mobile-nav-item:not(.active)').off("click").on("click", function(e) {
        //     $(this).addClass('active');
        // });

        // $('.mobile-nav-item.active a, .mobile-nav-item.active span').off("click").on("click", function(e) {
        //     $(this).removeClass('active');
        // });

        
     

    };

    function responsiveVid(){
        if( $('iframe').length > 0 ){
            // Find all YouTube videos
            var $allVideos = $("iframe");

                // The element that is fluid width
                if( $('.small-wrapper').length > 0 ){
                    var $fluidEl = $('#page-content .small-wrapper');

                } else if( $('.wrapper').length > 0 ){
                    var $fluidEl = $('#page-content .wrapper');

                } else if( $('.large-wrapper').length > 0 ){
                    var $fluidEl = $('#page-content .large-wrapper');
                }

            // Figure out and save aspect ratio for each video
            $allVideos.each(function() {

              $(this)
                .data('aspectRatio', this.height / this.width)

                // and remove the hard coded width/height
                .removeAttr('height')
                .removeAttr('width');

            });

            // When the window is resized
            $(window).resize(function() {

              var newWidth = $fluidEl.width();

              // Resize all videos according to their own aspect ratio
              $allVideos.each(function() {

                var $el = $(this);
                $el
                  .width(newWidth)
                  .height(newWidth * $el.data('aspectRatio'));

              });

            // Kick off one resize to fix all videos on page load
            }).resize();
        }
    }

    function slick(){

        if( $('.init-slick-fade').length > 0 ){
            $('.init-slick-fade').slick({
                dots: false,
                infinite: true,
                speed: 1800,
                autoplaySpeed: 2800,
                draggable: true,

                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: false,

                easing: 'easeOutCubic',
                autoplay: true,
                fade: true,
                arrows: true,  
                appendArrows: '#slick-arrows', 
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="15" fill="#D8E0EC" fill-opacity="0.9"/><path d="M17.9113 22.6817L10.5 15.0908L17.9113 7.5" fill="#D8E0EC" fill-opacity="0.9"/><path d="M17.9113 22.6817L10.5 15.0908L17.9113 7.5" stroke="#231F20" stroke-width="2" stroke-miterlimit="10"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="15" transform="rotate(-180 15 15)" fill="#D8E0EC" fill-opacity="0.9"/><path d="M12.0887 7.31833L19.5 14.9092L12.0887 22.5" fill="#D8E0EC" fill-opacity="0.9"/><path d="M12.0887 7.31833L19.5 14.9092L12.0887 22.5" stroke="#231F20" stroke-width="2" stroke-miterlimit="10"/></svg></button>',

                responsive: [
                  {
                    breakpoint: 800,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
            });
        }


        if( $('.init-slick-carousel--6x').length > 0 ){
            $('.init-slick-carousel--6x').each(function() {
                $(this).slick({
                    dots: false,
                    infinite: true,
                    speed: 1800,
                    autoplaySpeed: 2800,
                    draggable: true,

                    slidesToShow: 6,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '0',
                    variableWidth: false,
                    adaptiveHeight: false,

                    easing: 'easeOutCubic',
                    autoplay: true,
                    arrows: true,  
                    appendArrows: $(this).parents('.collection-callout').find('.slick-6x-arrow-container'), 
                    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none"><path d="M12 1L1 11L12 21" stroke="#B29F3B"/></button>',
                    nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none"><path d="M1 21L12 11L1 1" stroke="#B29F3B"/></button>',

                    responsive: [
                      {
                        breakpoint: 900,
                        arrows: false, 
                        settings: {
                          slidesToShow: 4,
                          slidesToScroll: 1
                        }
                      },
                      {
                        breakpoint: 480,
                        arrows: false, 
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '0',
                            variableWidth: false,
                            adaptiveHeight: false
                        }
                      }
                    ]
                });
            });
        }




        if( $('.init-slick-carousel--centermode').length > 0 ){
            $('.init-slick-carousel--centermode').each(function() {
                $(this).slick({
                    dots: false,
                    infinite: true,
                    speed: 1800,
                    autoplaySpeed: 2800,
                    draggable: true,

                    slidesToShow: 5,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '0px',
                    variableWidth: false,
                    adaptiveHeight: false,

                    easing: 'easeOutCubic',
                    autoplay: true,
                    arrows: true,  
                    // appendArrows: $(this).parents('.collection-callout').find('.init-slick-carousel--centermode'), 
                    prevArrow: '<button type="button" class="slick-btn slick-prev" aria-label="Previous slide"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="15" fill="#D8E0EC" fill-opacity="0.9"/><path d="M17.9113 22.6817L10.5 15.0908L17.9113 7.5" fill="#D8E0EC" fill-opacity="0.9"/><path d="M17.9113 22.6817L10.5 15.0908L17.9113 7.5" stroke="#231F20" stroke-width="2" stroke-miterlimit="10"/></svg></button>',
                    nextArrow: '<button type="button" class="slick-btn slick-next" aria-label="Next slide"><svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="15" transform="rotate(-180 15 15)" fill="#D8E0EC" fill-opacity="0.9"/><path d="M12.0887 7.31833L19.5 14.9092L12.0887 22.5" fill="#D8E0EC" fill-opacity="0.9"/><path d="M12.0887 7.31833L19.5 14.9092L12.0887 22.5" stroke="#231F20" stroke-width="2" stroke-miterlimit="10"/></svg></button>',

                    responsive: [
                      {
                        breakpoint: 900,
                        arrows: false, 
                        settings: {
                          slidesToShow: 4,
                          slidesToScroll: 1
                        }
                      },
                      {
                        breakpoint: 480,
                        arrows: false, 
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            centerMode: true,
                            centerPadding: '0',
                            variableWidth: false,
                            adaptiveHeight: false
                        }
                      }
                    ]
                });
            });
        }        

        if( $('.init-slick-carousel--3x').length > 0 ){
            $('.init-slick-carousel--3x').slick({
                dots: false,
                infinite: true,
                speed: 1800,
                autoplaySpeed: 2800,
                draggable: true,

                slidesToShow: 3,
                slidesToScroll: 3,
                centerMode: true,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: false,

                easing: 'easeOutCubic',
                autoplay: true,
                arrows: true,  
                appendArrows: '#arrow-container-3x', 
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none"><path d="M-3.49691e-07 7L12 0.071794L12 13.9282L-3.49691e-07 7Z" fill="#76777B"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none"><path d="M12 7L3.01142e-07 13.9282L9.06825e-07 0.0717964L12 7Z" fill="#76777B"/></svg></button>',

                responsive: [
                  {
                    breakpoint: 800,
                    arrows: false, 
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    arrows: false, 
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  }
                ]
            });
        }



        if( $(window).width() < 500 && $('.sm-init-slick-carousel--3x').length > 0 ){
            $('.sm-init-slick-carousel--3x').slick({
                dots: false,
                infinite: true,
                speed: 2000,
                autoplaySpeed: 3000,
                draggable: true,

                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: false,

                easing: 'easeOutCubic',
                autoplay: true,
                arrows: true,  
                // appendArrows: '#arrow-container-3x', 
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none"><path d="M12 1L1 11L12 21" stroke="#76777B"/></button>',
                    nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none"><path d="M1 21L12 11L1 1" stroke="#76777B"/></button>',

                responsive: [
                ]
            });
        }

        if( $(window).width() < 500 && $('.sm-init-slick-carousel--3x--centered').length > 0 ){
            $('.sm-init-slick-carousel--3x--centered').slick({
                dots: false,
                infinite: true,
                speed: 2000,
                autoplaySpeed: 3000,
                draggable: true,

                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '0',
                variableWidth: true,
                adaptiveHeight: false,

                easing: 'easeOutCubic',
                autoplay: true,
                arrows: true,  
                // appendArrows: '#arrow-container-3x', 
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none"><path d="M12 1L1 11L12 21" stroke="#76777B"/></button>',
                    nextArrow: '<button type="button" class="slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="22" viewBox="0 0 13 22" fill="none"><path d="M1 21L12 11L1 1" stroke="#76777B"/></button>',

                responsive: [
                ]
            });
        }

        

        if( $('.init-slick-carousel2').length > 0 ){
            $('.init-slick-carousel2').slick({
                dots: false,
                infinite: true,
                speed: 2000,
                autoplaySpeed: 3000,
                draggable: true,

                slidesToShow: 5,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: false,

                easing: 'easeOutCubic',
                autoplay: true,
                arrows: false,  
                // appendArrows: '#arrow-container', 
                // prevArrow: '<button type="button" class="slick-prev"></button>',
                // nextArrow: '<button type="button" class="slick-next"></button>',

                responsive: [
                  {
                    breakpoint: 800,
                    arrows: false, 
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    arrows: false, 
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  }
                ]
            });
        }
    }

    function mason_grid(){
        if( $('.masonry-grid').length > 0 ) {
            
            function domason(){
                console.log('asdf');
                $('.masonry-grid').isotope({
                  itemSelector: '.grid_item',
                  layoutMode: 'masonry'
                });
            }
            domason();

            setTimeout(function(){
                domason();
            }, 2000);

        };
    };


    $(window).ready(function(){
        general();
        general_resp();
        slick();
        mason_grid();
        // about();
    });


    $(window).resize(function(){
       general();
       general_resp();
    });
});     